import { UserRole } from 'shared';
import { DeliveryTaskType } from 'shared';

export class TaskCollectionValidation {
    public userRoles: UserRole[];
    public deliveryTypes: DeliveryTaskType[];
}
